import { Component } from '@angular/core';

@Component({
  selector: 'app-user-agreement-page',
  templateUrl: './user-agreement-page.component.html',
  styleUrls: ['./user-agreement-page.component.scss'],
})
export class UserAgreementPageComponent {}
